import { render, staticRenderFns } from "./BudgetForOneDepartment.vue?vue&type=template&id=21582156&"
import script from "./BudgetForOneDepartment.vue?vue&type=script&lang=js&"
export * from "./BudgetForOneDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports